module.exports = __webpack_public_path__ + "media/features/audio-hero/images/phones_de@2x-152daa384c9d0b4d54d5ab15691a7862.png";